import type { DrawerHeaderProps } from "../../shared/Drawer";
import type { FormState } from "../DynamicFormProvider";

export const formStateToDrawerHeaderStatus = (formState: FormState): DrawerHeaderProps["status"] => {
  return formState.isReadOnly ? "readonly" : formState.isSaveError ? "error" : formState.isSaving ? "pending" : "idle";
};
